import { useNavigate } from "react-router-dom";

const baseURL = process.env.REACT_APP_API_URL;

function useFetch() {
  const navigation = useNavigate();
  const myFetch = async (url, options) => {
    let token = localStorage.getItem("token");
    if (options.headers) {
      options.headers.Authorization = `Bearer ${token}`;
    } else {
      options.headers = { Authorization: `Bearer ${token}` };
    }

    let resp = await fetch(`${baseURL}/${url}`, options);

    if (resp.status === 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      navigation("/login");
    }
    return resp;
  };
  return { myFetch };
}

export { baseURL, useFetch };
